<template>
  <div
    class="modal fade"
    id="notifyBillsModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div
      class="modal-dialog modal-dialog-centered modal-simple modal-upgrade-plan"
    >
      <div class="modal-content">
        <div class="modal-body p-4">
          <button
            type="button"
            id="notify-bill-close"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div class="text-center mb-6">
            <h4 class="mb-2 text-success">
              {{ $t("bills.pay_bill") }}
            </h4>
          </div>
          <hr class="mx-4 my-2" />

          <form
            id="upgradePlanForm"
            class="row g-4 mt-2"
            onsubmit="return false"
          >
            <div class="col-12">
              <label class="form-label" for="operationTime">{{
                $t("bills.slug")
              }}</label>
              <input
                type="text"
                disabled
                v-model="selectedBill.slug"
                class="form-control"
              />
            </div>
            <div class="col-12" v-if="selectedBill.account">
              <label class="form-label" for="operationTime">{{
                $t("bills.account")
              }}</label>
              <input
                type="text"
                disabled
                v-model="selectedBill.account.username"
                class="form-control"
              />
            </div>
            <div class="col-12" v-if="selectedBill.account">
              <label class="form-label" for="operationTime">{{
                $t("notifications.notification_text")
              }}</label>
              <textarea
                rows="12"
                disabled
                :value="notificationMessage"
                class="form-control"
              />
            </div>
            <div class="col-12 text-center mt-12">
              <button
                class="btn btn-success me-2"
                type="button"
                @click="notifyBill(selectedBill)"
              >
                <i class="ti ti-bill me-1"></i>
                {{ $t("bills.notify") }}
              </button>
              <button
                type="reset"
                class="btn btn-label-secondary"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                {{ $t("control.cancel") }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  name: "BillsNotify",
  computed: {
    ...mapGetters(["settings"]),
  },
  data() {
    return {
      notificationMessage: "",
    };
  },
  props: {
    selectedBill: {
      type: Object,
      required: true,
    },
  },
  created() {
    if (!this.selectedBill.account) return;
    this.notificationMessage = "مشترك ";
    this.notificationMessage += `${this.selectedBill.account.first_name} ${this.selectedBill.account.last_name}\n`;
    this.notificationMessage += `هذا الاشعار لتذكيرك بتسديد الفاتورة: `;
    this.notificationMessage += ` من تاريخ: `;
    this.notificationMessage += `${this.selectedBill.created_at}\n`;
    this.notificationMessage += `وذلك لقاء اشتراك الانترنت `;
    this.notificationMessage += `${this.selectedBill.profile.name} `;
    this.notificationMessage += `في شبكة `;
    this.notificationMessage += this.settings.network_name + "\n";
    this.notificationMessage += `المطلوب: `;
    this.notificationMessage += `${this.selectedBill.price}`;
    this.notificationMessage += `${this.settings.currency}\n`;
    this.notificationMessage += `المدفوع: `;
    this.notificationMessage += `${this.selectedBill.paid}`;
    this.notificationMessage += `${this.settings.currency}\n`;
    this.notificationMessage += `المتبقي: `;
    var remain = this.selectedBill.price - this.selectedBill.paid;
    this.notificationMessage += `${remain}`;
    this.notificationMessage += `${this.settings.currency}\n`;
    this.notificationMessage += `مجموع الديون الاجمالي: `;
    this.notificationMessage += `{مجموع_الديون}\n`;
    this.notificationMessage += `\n`;
    this.notificationMessage += `Powered by SSR`;
  },
  methods: {
    async notifyBill(bill) {
      const message = this.$t("bills.notification_sent");
      document.getElementById("notify-bill-close").click();
      try {
        const response = await axios.post(`bills/${bill.id}/notification`, {
          amount: bill.paid,
        });
        if (response.status == 200) {
          this.$notify({
            text: message,
            type: "success",
          });
        }
      } catch (error) {
        this.$notify({
          text:
            error.response?.data?.message ||
            this.$t("control.some_thing_went_wrong_please_try_again"),
          type: "error",
        });
      }
      this.$emit("updated");
    },
  },
};
</script>
